import { render } from "./RosterUpdate.vue?vue&type=template&id=04ea860f&scoped=true"
import script from "./RosterUpdate.vue?vue&type=script&lang=js"
export * from "./RosterUpdate.vue?vue&type=script&lang=js"

import "./RosterUpdate.vue?vue&type=style&index=0&id=04ea860f&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\四个火体育_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04ea860f"]])

export default __exports__